import React, { useRef, useState, useEffect } from 'react';
import "./i18n"; //import this
import { useTranslation } from "react-i18next";

import Alert from 'react-bootstrap/Alert';
// import Col from 'react-bootstrap/Col';
// import Row from 'react-bootstrap/Row';
import Container from 'react-bootstrap/Container';

import Chart from './apichart';
import Navy from './navy';
import PHS from './PHS';

/* The following line can be included in your src/index.js or App.js file */
import 'bootstrap/dist/css/bootstrap.min.css';

// import Sponso from './Sponsor';
// import Story from './Story'
import Map from './Map'
// import MapCam from './MapCamStory'
// import MapTrack from './MapTrack'

import Clock from "./montre";

import Login from './login';
import Contact from './contact'; // Assurez-vous que le chemin est correct




import * as React from 'react';
import SimpleBottomNavigation from './nav'


import logo from '../image/logo.jpg';


import topo_style from '../styles/swisstopo-basiskarte.json';
import swissimage_style from '../styles/swisstopo-basiskarte-imagery.json';
import smooth_style from '../styles/alidade_smooth.json';
import dark_style from '../styles/alidade_smooth_dark.json';
import outdoor_style from '../styles/outdoors.json';



// const topo_style = 'https://vectortiles.geo.admin.ch/styles/ch.swisstopo.leichte-basiskarte.vt/style.json';
// const swissimage_style = 'https://vectortiles.geo.admin.ch/styles/ch.swisstopo.leichte-basiskarte-imagery.vt/style.json';

// // .COM
// const smooth_style = 'https://tiles.stadiamaps.com/styles/alidade_smooth.json?api_key=a2a467aa-8dcf-4ee2-939f-6185f11f1876';
// const dark_style = 'https://tiles.stadiamaps.com/styles/alidade_smooth_dark.json?api_key=a2a467aa-8dcf-4ee2-939f-6185f11f1876';
// const outdoor_style = 'https://tiles.stadiamaps.com/styles/outdoors.json?api_key=a2a467aa-8dcf-4ee2-939f-6185f11f1876';
// // 

// // .CH
// const smooth_style = 'https://tiles.stadiamaps.com/styles/alidade_smooth.json?api_key=a33bbea2-83a7-410b-8d1e-68839e7eb930';
// const dark_style = 'https://tiles.stadiamaps.com/styles/alidade_smooth_dark.json?api_key=a33bbea2-83a7-410b-8d1e-68839e7eb930';
// const outdoor_style = 'https://tiles.stadiamaps.com/styles/outdoors.json?api_key=a33bbea2-83a7-410b-8d1e-68839e7eb930';
// // 


// const topo_style = 'https://vectortiles.geo.admin.ch/styles/ch.swisstopo.leichte-basiskarte.vt/style.json';
// const swissimage_style = 'https://vectortiles.geo.admin.ch/styles/ch.swisstopo.leichte-basiskarte-imagery.vt/style.json';
// const smooth_style = 'https://tiles.stadiamaps.com/styles/alidade_smooth.json';
// const dark_style = 'https://tiles.stadiamaps.com/styles/alidade_smooth_dark.json';
// const outdoor_style = 'https://tiles.stadiamaps.com/styles/outdoors.json';


// // const pointSource = {"type":"geojson","data":{"type":"FeatureCollection","features":[{"type":"Feature","properties":{"spot_id":"1-meteowind-iot-pro","spotname":"Conches","icon":"logo","windave":"1.20","windir":"273"},"geometry":{"type":"Point","coordinates":[6.178138,46.1887]}},{"type":"Feature","properties":{"spot_id":"CHGE03","spotname":"Gen\u00e8ve - Soci\u00e9t\u00e9 Nautique","icon":"logo","windave":"2.92","windir":"289"},"geometry":{"type":"Point","coordinates":[6.171121,46.21425]}},{"type":"Feature","properties":{"spot_id":"eui-a84041458183d120","spotname":"Conche_s","icon":"logo","windave":null,"windir":null},"geometry":{"type":"Point","coordinates":[6.179498,46.188946]}},{"type":"Feature","properties":{"spot_id":"temp-hum-1","spotname":"Anniviers","icon":"logo","windave":null,"windir":null},"geometry":{"type":"Point","coordinates":[7.598573,46.251403]}},{"type":"Feature","properties":{"spot_id":"CHGE02","spotname":"Versoix - Club Nautique","icon":"logo","windave":"1.78","windir":"89"},"geometry":{"type":"Point","coordinates":[6.170723,46.289068]}},{"type":"Feature","properties":{"spot_id":"CHGE04","spotname":"Sal\u00e8ve - Les Cr\u00eats","icon":"logo","windave":"10.69","windir":"83"},"geometry":{"type":"Point","coordinates":[6.172977,46.128239]}},{"type":"Feature","properties":{"spot_id":"CHGE06","spotname":"Sal\u00e8ve - La Table","icon":"logo","windave":"0.00","windir":"0"},"geometry":{"type":"Point","coordinates":[6.188925,46.148539]}},{"type":"Feature","properties":{"spot_id":"CHGE05","spotname":"Troinex","icon":"logo","windave":null,"windir":null},"geometry":{"type":"Point","coordinates":[6.157252,46.162252]}},{"type":"Feature","properties":{"spot_id":"CHVD12","spotname":"Centre Lausannois Aviron","icon":"logo","windave":"0.00","windir":"76"},"geometry":{"type":"Point","coordinates":[6.601139,46.512496]}},{"type":"Feature","properties":{"spot_id":"CHVD15","spotname":"Corseaux - La Pichette","icon":"logo","windave":"2.11","windir":"236"},"geometry":{"type":"Point","coordinates":[6.811508,46.469174]}},{"type":"Feature","properties":{"spot_id":"CHVS02","spotname":"Planachaux","icon":"logo","windave":"0.00","windir":"267"},"geometry":{"type":"Point","coordinates":[6.840267,46.177117]}},{"type":"Feature","properties":{"spot_id":"vengeron","spotname":"Vengeron.net","icon":"logo","windave":"0.00","windir":"225"},"geometry":{"type":"Point","coordinates":[6.153731,46.245619]}}]}}
// const pointSource = {"type":"geojson","data":{"type":"FeatureCollection","features":[{"type":"Feature","properties":{"spot_id":"1-meteowind-iot-pro","spotname":"Conches","icon":"logo","windave":"1.30","windir":"51","Battery":"4.2","Wind_3sgust":"3.90","Wind_3smin":"0.00","Wind_stdev":"1.60","Dir_3sgust":"226","Dir_stdev":"127","gust_3stime":"180","Pression":null,"dewpoint":null,"Hum_SHT":null,"TempC_DS":null,"TempC_SHT":null,"Temp_Black":null,"Temp_Red":null,"Temp_White":null},"geometry":{"type":"Point","coordinates":[6.173048,46.186563]}},{"type":"Feature","properties":{"spot_id":"CHGE03","spotname":"Soci\u00e9t\u00e9 Nautique de Gen\u00e8ve","icon":"logo","windave":"17.17","windir":"150","Battery":null,"Wind_3sgust":"19.44","Wind_3smin":null,"Wind_stdev":null,"Dir_3sgust":null,"Dir_stdev":null,"gust_3stime":null,"Pression":"1003","dewpoint":null,"Hum_SHT":null,"TempC_DS":null,"TempC_SHT":"28.00","Temp_Black":null,"Temp_Red":null,"Temp_White":null},"geometry":{"type":"Point","coordinates":[6.171121,46.21425]}},{"type":"Feature","properties":{"spot_id":"eui-a84041458183d120","spotname":"Conche_s","icon":"logo","windave":null,"windir":null,"Battery":null,"Wind_3sgust":null,"Wind_3smin":null,"Wind_stdev":null,"Dir_3sgust":null,"Dir_stdev":null,"gust_3stime":null,"Pression":null,"dewpoint":null,"Hum_SHT":"42.0","TempC_DS":null,"TempC_SHT":"28.36","Temp_Black":null,"Temp_Red":null,"Temp_White":null},"geometry":{"type":"Point","coordinates":[6.179498,46.188946]}},{"type":"Feature","properties":{"spot_id":"temp-hum-1","spotname":"Anniviers","icon":"logo","windave":null,"windir":null,"Battery":null,"Wind_3sgust":null,"Wind_3smin":null,"Wind_stdev":null,"Dir_3sgust":null,"Dir_stdev":null,"gust_3stime":null,"Pression":null,"dewpoint":null,"Hum_SHT":"52.5","TempC_DS":null,"TempC_SHT":"20.60","Temp_Black":null,"Temp_Red":null,"Temp_White":null},"geometry":{"type":"Point","coordinates":[7.598573,46.251403]}},{"type":"Feature","properties":{"spot_id":"CHGE02","spotname":"Versoix - Club Nautique","icon":"logo","windave":"9.56","windir":"228","Battery":null,"Wind_3sgust":"15.55","Wind_3smin":null,"Wind_stdev":null,"Dir_3sgust":null,"Dir_stdev":null,"gust_3stime":null,"Pression":"1004","dewpoint":null,"Hum_SHT":null,"TempC_DS":null,"TempC_SHT":"31.00","Temp_Black":null,"Temp_Red":null,"Temp_White":null},"geometry":{"type":"Point","coordinates":[6.170723,46.289068]}},{"type":"Feature","properties":{"spot_id":"CHGE04","spotname":"Sal\u00e8ve - Les Cr\u00eats","icon":"logo","windave":"32.07","windir":"5","Battery":null,"Wind_3sgust":"33.69","Wind_3smin":null,"Wind_stdev":null,"Dir_3sgust":null,"Dir_stdev":null,"gust_3stime":null,"Pression":"1005","dewpoint":null,"Hum_SHT":null,"TempC_DS":null,"TempC_SHT":"21.00","Temp_Black":null,"Temp_Red":null,"Temp_White":null},"geometry":{"type":"Point","coordinates":[6.172977,46.128239]}},{"type":"Feature","properties":{"spot_id":"CHGE06","spotname":"Sal\u00e8ve - La Table","icon":"logo","windave":"5.51","windir":"192","Battery":null,"Wind_3sgust":"7.78","Wind_3smin":null,"Wind_stdev":null,"Dir_3sgust":null,"Dir_stdev":null,"gust_3stime":null,"Pression":"1008","dewpoint":null,"Hum_SHT":null,"TempC_DS":null,"TempC_SHT":"22.00","Temp_Black":null,"Temp_Red":null,"Temp_White":null},"geometry":{"type":"Point","coordinates":[6.188925,46.148539]}},{"type":"Feature","properties":{"spot_id":"CHGE05","spotname":"Troinex","icon":"logo","windave":"9.72","windir":"202","Battery":null,"Wind_3sgust":"12.31","Wind_3smin":null,"Wind_stdev":null,"Dir_3sgust":null,"Dir_stdev":null,"gust_3stime":null,"Pression":"1005","dewpoint":null,"Hum_SHT":null,"TempC_DS":null,"TempC_SHT":"30.00","Temp_Black":null,"Temp_Red":null,"Temp_White":null},"geometry":{"type":"Point","coordinates":[6.157252,46.162252]}},{"type":"Feature","properties":{"spot_id":"CHVD12","spotname":"Centre Lausannois Aviron","icon":"logo","windave":"0.00","windir":"0","Battery":null,"Wind_3sgust":"0.00","Wind_3smin":null,"Wind_stdev":null,"Dir_3sgust":null,"Dir_stdev":null,"gust_3stime":null,"Pression":null,"dewpoint":null,"Hum_SHT":null,"TempC_DS":null,"TempC_SHT":null,"Temp_Black":null,"Temp_Red":null,"Temp_White":null},"geometry":{"type":"Point","coordinates":[6.601139,46.512496]}},{"type":"Feature","properties":{"spot_id":"CHVD15","spotname":"Corseaux - La Pichette","icon":"logo","windave":"7.13","windir":"253","Battery":null,"Wind_3sgust":"9.07","Wind_3smin":null,"Wind_stdev":null,"Dir_3sgust":null,"Dir_stdev":null,"gust_3stime":null,"Pression":"1005","dewpoint":null,"Hum_SHT":null,"TempC_DS":null,"TempC_SHT":"26.00","Temp_Black":null,"Temp_Red":null,"Temp_White":null},"geometry":{"type":"Point","coordinates":[6.811508,46.469174]}},{"type":"Feature","properties":{"spot_id":"CHVS02","spotname":"Planachaux","icon":"logo","windave":"55.83","windir":"230","Battery":null,"Wind_3sgust":"60.80","Wind_3smin":null,"Wind_stdev":null,"Dir_3sgust":null,"Dir_stdev":null,"gust_3stime":null,"Pression":null,"dewpoint":null,"Hum_SHT":null,"TempC_DS":null,"TempC_SHT":"16.50","Temp_Black":null,"Temp_Red":null,"Temp_White":null},"geometry":{"type":"Point","coordinates":[6.840267,46.177117]}},{"type":"Feature","properties":{"spot_id":"vengeron","spotname":"Vengeron.net","icon":"logo","windave":"0.00","windir":"180","Battery":null,"Wind_3sgust":"0.40","Wind_3smin":null,"Wind_stdev":null,"Dir_3sgust":null,"Dir_stdev":null,"gust_3stime":null,"Pression":null,"dewpoint":"14.3","Hum_SHT":"45.0","TempC_DS":null,"TempC_SHT":"27.30","Temp_Black":"15.60","Temp_Red":"15.60","Temp_White":"15.60"},"geometry":{"type":"Point","coordinates":[6.153731,46.245619]}},{"type":"Feature","properties":{"spot_id":"CHGE03","spotname":"Soci\u00e9t\u00e9 Nautique de Gen\u00e8ve","icon":"logo","windave":"17.17","windir":"150","Battery":null,"Wind_3sgust":"19.44","Wind_3smin":null,"Wind_stdev":null,"Dir_3sgust":null,"Dir_stdev":null,"gust_3stime":null,"Pression":"1003","dewpoint":null,"Hum_SHT":null,"TempC_DS":null,"TempC_SHT":"28.00","Temp_Black":null,"Temp_Red":null,"Temp_White":null},"geometry":{"type":"Point","coordinates":[6.171121,46.21425]}}]}}

// const pointSource = {"type":"geojson","data":{"type":"FeatureCollection","features":[{"type":"Feature","properties":{"spot_id":"1-meteowind-iot-pro","spotname":"Conches","webcamlink":"null","webcamlink2":"null","webcamlink3":"null","webcamlink4":"null","icon":"logo","windave":"1.30","windir":"51","Battery":"4.2","Wind_3sgust":"3.90","Wind_3smin":"0.00","Wind_stdev":"1.60","Dir_3sgust":"226","Dir_stdev":"127","gust_3stime":"180","Pression":null,"dewpoint":null,"Hum_SHT":null,"TempC_DS":null,"TempC_SHT":null,"Temp_Black":null,"Temp_Red":null,"Temp_White":null},"geometry":{"type":"Point","coordinates":[6.173048,46.186563]}},{"type":"Feature","properties":{"spot_id":"CHGE03","spotname":"Soci\u00e9t\u00e9 Nautique de Gen\u00e8ve","webcamlink":"null","webcamlink2":"null","webcamlink3":"null","webcamlink4":"null","icon":"logo","windave":"17.17","windir":"150","Battery":null,"Wind_3sgust":"19.44","Wind_3smin":null,"Wind_stdev":null,"Dir_3sgust":null,"Dir_stdev":null,"gust_3stime":null,"Pression":"1003","dewpoint":null,"Hum_SHT":null,"TempC_DS":null,"TempC_SHT":"28.00","Temp_Black":null,"Temp_Red":null,"Temp_White":null},"geometry":{"type":"Point","coordinates":[6.171121,46.21425]}},{"type":"Feature","properties":{"spot_id":"eui-a84041458183d120","spotname":"Conche_s","webcamlink":"null","webcamlink2":"null","webcamlink3":"null","webcamlink4":"null","icon":"logo","windave":null,"windir":null,"Battery":null,"Wind_3sgust":null,"Wind_3smin":null,"Wind_stdev":null,"Dir_3sgust":null,"Dir_stdev":null,"gust_3stime":null,"Pression":null,"dewpoint":null,"Hum_SHT":"42.0","TempC_DS":null,"TempC_SHT":"28.36","Temp_Black":null,"Temp_Red":null,"Temp_White":null},"geometry":{"type":"Point","coordinates":[6.179498,46.188946]}},{"type":"Feature","properties":{"spot_id":"temp-hum-1","spotname":"Anniviers","webcamlink":"null","webcamlink2":"null","webcamlink3":"null","webcamlink4":"null","icon":"logo","windave":null,"windir":null,"Battery":null,"Wind_3sgust":null,"Wind_3smin":null,"Wind_stdev":null,"Dir_3sgust":null,"Dir_stdev":null,"gust_3stime":null,"Pression":null,"dewpoint":null,"Hum_SHT":"52.5","TempC_DS":null,"TempC_SHT":"20.60","Temp_Black":null,"Temp_Red":null,"Temp_White":null},"geometry":{"type":"Point","coordinates":[7.598573,46.251403]}},{"type":"Feature","properties":{"spot_id":"CHGE02","spotname":"Versoix - Club Nautique","webcamlink":"null","webcamlink2":"null","webcamlink3":"null","webcamlink4":"null","icon":"logo","windave":"9.56","windir":"228","Battery":null,"Wind_3sgust":"15.55","Wind_3smin":null,"Wind_stdev":null,"Dir_3sgust":null,"Dir_stdev":null,"gust_3stime":null,"Pression":"1004","dewpoint":null,"Hum_SHT":null,"TempC_DS":null,"TempC_SHT":"31.00","Temp_Black":null,"Temp_Red":null,"Temp_White":null},"geometry":{"type":"Point","coordinates":[6.170723,46.289068]}},{"type":"Feature","properties":{"spot_id":"CHGE04","spotname":"Sal\u00e8ve - Les Cr\u00eats","webcamlink":"null","webcamlink2":"null","webcamlink3":"null","webcamlink4":"null","icon":"logo","windave":"32.07","windir":"5","Battery":null,"Wind_3sgust":"33.69","Wind_3smin":null,"Wind_stdev":null,"Dir_3sgust":null,"Dir_stdev":null,"gust_3stime":null,"Pression":"1005","dewpoint":null,"Hum_SHT":null,"TempC_DS":null,"TempC_SHT":"21.00","Temp_Black":null,"Temp_Red":null,"Temp_White":null},"geometry":{"type":"Point","coordinates":[6.172977,46.128239]}},{"type":"Feature","properties":{"spot_id":"CHGE06","spotname":"Sal\u00e8ve - La Table","webcamlink":"null","webcamlink2":"null","webcamlink3":"null","webcamlink4":"null","icon":"logo","windave":"5.51","windir":"192","Battery":null,"Wind_3sgust":"7.78","Wind_3smin":null,"Wind_stdev":null,"Dir_3sgust":null,"Dir_stdev":null,"gust_3stime":null,"Pression":"1008","dewpoint":null,"Hum_SHT":null,"TempC_DS":null,"TempC_SHT":"22.00","Temp_Black":null,"Temp_Red":null,"Temp_White":null},"geometry":{"type":"Point","coordinates":[6.188925,46.148539]}},{"type":"Feature","properties":{"spot_id":"CHGE05","spotname":"Troinex","webcamlink":"null","webcamlink2":"null","webcamlink3":"null","webcamlink4":"null","icon":"logo","windave":"9.72","windir":"202","Battery":null,"Wind_3sgust":"12.31","Wind_3smin":null,"Wind_stdev":null,"Dir_3sgust":null,"Dir_stdev":null,"gust_3stime":null,"Pression":"1005","dewpoint":null,"Hum_SHT":null,"TempC_DS":null,"TempC_SHT":"30.00","Temp_Black":null,"Temp_Red":null,"Temp_White":null},"geometry":{"type":"Point","coordinates":[6.157252,46.162252]}},{"type":"Feature","properties":{"spot_id":"CHVD12","spotname":"Centre Lausannois Aviron","webcamlink":"null","webcamlink2":"null","webcamlink3":"null","webcamlink4":"null","icon":"logo","windave":"0.00","windir":"0","Battery":null,"Wind_3sgust":"0.00","Wind_3smin":null,"Wind_stdev":null,"Dir_3sgust":null,"Dir_stdev":null,"gust_3stime":null,"Pression":null,"dewpoint":null,"Hum_SHT":null,"TempC_DS":null,"TempC_SHT":null,"Temp_Black":null,"Temp_Red":null,"Temp_White":null},"geometry":{"type":"Point","coordinates":[6.601139,46.512496]}},{"type":"Feature","properties":{"spot_id":"CHVD15","spotname":"Corseaux - La Pichette","webcamlink":"null","webcamlink2":"null","webcamlink3":"null","webcamlink4":"null","icon":"logo","windave":"7.13","windir":"253","Battery":null,"Wind_3sgust":"9.07","Wind_3smin":null,"Wind_stdev":null,"Dir_3sgust":null,"Dir_stdev":null,"gust_3stime":null,"Pression":"1005","dewpoint":null,"Hum_SHT":null,"TempC_DS":null,"TempC_SHT":"26.00","Temp_Black":null,"Temp_Red":null,"Temp_White":null},"geometry":{"type":"Point","coordinates":[6.811508,46.469174]}},{"type":"Feature","properties":{"spot_id":"CHVS02","spotname":"Planachaux","webcamlink":"null","webcamlink2":"null","webcamlink3":"null","webcamlink4":"null","icon":"logo","windave":"55.83","windir":"230","Battery":null,"Wind_3sgust":"60.80","Wind_3smin":null,"Wind_stdev":null,"Dir_3sgust":null,"Dir_stdev":null,"gust_3stime":null,"Pression":null,"dewpoint":null,"Hum_SHT":null,"TempC_DS":null,"TempC_SHT":"16.50","Temp_Black":null,"Temp_Red":null,"Temp_White":null},"geometry":{"type":"Point","coordinates":[6.840267,46.177117]}},{"type":"Feature","properties":{"spot_id":"vengeron","spotname":"Vengeron.net","webcamlink":"null","webcamlink2":"null","webcamlink3":"null","webcamlink4":"null","icon":"logo","windave":"0.00","windir":"180","Battery":null,"Wind_3sgust":"0.40","Wind_3smin":null,"Wind_stdev":null,"Dir_3sgust":null,"Dir_stdev":null,"gust_3stime":null,"Pression":null,"dewpoint":"14.3","Hum_SHT":"45.0","TempC_DS":null,"TempC_SHT":"27.30","Temp_Black":"15.60","Temp_Red":"15.60","Temp_White":"15.60"},"geometry":{"type":"Point","coordinates":[6.153731,46.245619]}},{"type":"Feature","properties":{"spot_id":"CHGE03","spotname":"Soci\u00e9t\u00e9 Nautique de Gen\u00e8ve","webcamlink":"null","webcamlink2":"null","webcamlink3":"null","webcamlink4":"null","icon":"logo","windave":"17.17","windir":"150","Battery":null,"Wind_3sgust":"19.44","Wind_3smin":null,"Wind_stdev":null,"Dir_3sgust":null,"Dir_stdev":null,"gust_3stime":null,"Pressure":"1003","dewpoint":null,"Hum_SHT":null,"TempC_DS":null,"TempC_SHT":"28.00","Temp_Black":null,"Temp_Red":null,"Temp_White":null},"geometry":{"type":"Point","coordinates":[6.171121,46.21425]}}]}}
// const pointSource = {"type":"geojson","data":{"type":"FeatureCollection","features":[{"type":"Feature","properties":{"spot_id":"CHGE03","spotname":"Soci\u00e9t\u00e9 Nautique de Gen\u00e8ve","webcamlink":"","webcamlink2":null,"webcamlink3":null,"webcamlink4":null,"active":"1","source":"Windspots","icon":"logo","windave":"2.59","windir":"69","Battery":null,"Wind_3sgust":"2.59","Wind_3smin":null,"Wind_stdev":null,"Dir_3sgust":null,"Dir_stdev":null,"gust_3stime":null,"Pressure":"1016.00","dewpoint":null,"Hum_SHT":null,"TempC_DS":null,"TempC_SHT":"22.00","Temp_Black":null,"Temp_Red":null,"Temp_White":null},"geometry":{"type":"Point","coordinates":[6.171121,46.21425]}},{"type":"Feature","properties":{"spot_id":"1-meteowind-iot-pro","spotname":"Conches","webcamlink":"","webcamlink2":null,"webcamlink3":null,"webcamlink4":null,"active":"1","source":"TrueWindSpeed","icon":"logo","windave":"0.00","windir":"284","Battery":"4.2","Wind_3sgust":"2.50","Wind_3smin":"0.00","Wind_stdev":"0.70","Dir_3sgust":"255","Dir_stdev":"62","gust_3stime":"20","Pressure":null,"dewpoint":null,"Hum_SHT":null,"TempC_DS":null,"TempC_SHT":null,"Temp_Black":null,"Temp_Red":null,"Temp_White":null},"geometry":{"type":"Point","coordinates":[6.173048,46.186563]}},{"type":"Feature","properties":{"spot_id":"temp-hum-1","spotname":"Anniviers","webcamlink":"https:\/\/camstreamer.com\/embed\/lVNnl7WD9PUbCYZmVBHSHgLSS79a2ysf9JXtICAA","webcamlink2":"https:\/\/camstreamer.com\/embed\/zVhwkln0zC279WEHYTTlDaxQXP76eXWxCdNOfcmc","webcamlink3":"https:\/\/camstreamer.com\/embed\/5QSFHqNMXdfZPRsP6R4LRYG8PlFvzgOVxFoAMRfT","webcamlink4":"https:\/\/camstreamer.com\/embed\/oyMdMcmrYnc7jbdRoGGqhxIfykin6zuz8uPFuhye","active":"1","source":"TrueWindSpeed","icon":"logo","windave":null,"windir":null,"Battery":null,"Wind_3sgust":null,"Wind_3smin":null,"Wind_stdev":null,"Dir_3sgust":null,"Dir_stdev":null,"gust_3stime":null,"Pressure":null,"dewpoint":null,"Hum_SHT":"67.2","TempC_DS":null,"TempC_SHT":"14.50","Temp_Black":null,"Temp_Red":null,"Temp_White":null},"geometry":{"type":"Point","coordinates":[7.598573,46.251403]}},{"type":"Feature","properties":{"spot_id":"CHGE02","spotname":"Versoix - Club Nautique","webcamlink":"https:\/\/camstreamer.com\/embed\/oyMdMcmrYnc7jbdRoGGqhxIfykin6zuz8uPFuhye","webcamlink2":null,"webcamlink3":null,"webcamlink4":null,"active":"1","source":"Windspots","icon":"logo","windave":"0.00","windir":"321","Battery":null,"Wind_3sgust":"0.00","Wind_3smin":null,"Wind_stdev":null,"Dir_3sgust":null,"Dir_stdev":null,"gust_3stime":null,"Pressure":"1018.00","dewpoint":null,"Hum_SHT":null,"TempC_DS":null,"TempC_SHT":"22.50","Temp_Black":null,"Temp_Red":null,"Temp_White":null},"geometry":{"type":"Point","coordinates":[6.170723,46.289068]}},{"type":"Feature","properties":{"spot_id":"CHGE04","spotname":"Sal\u00e8ve - Les Cr\u00eats","webcamlink":"","webcamlink2":null,"webcamlink3":null,"webcamlink4":null,"active":"1","source":"Windspots","icon":"logo","windave":"0.00","windir":"0","Battery":null,"Wind_3sgust":"0.00","Wind_3smin":null,"Wind_stdev":null,"Dir_3sgust":null,"Dir_stdev":null,"gust_3stime":null,"Pressure":null,"dewpoint":null,"Hum_SHT":null,"TempC_DS":null,"TempC_SHT":null,"Temp_Black":null,"Temp_Red":null,"Temp_White":null},"geometry":{"type":"Point","coordinates":[6.172977,46.128239]}},{"type":"Feature","properties":{"spot_id":"CHGE06","spotname":"Sal\u00e8ve - La Table","webcamlink":"","webcamlink2":null,"webcamlink3":null,"webcamlink4":null,"active":"1","source":"Windspots","icon":"logo","windave":"0.00","windir":"0","Battery":null,"Wind_3sgust":"0.00","Wind_3smin":null,"Wind_stdev":null,"Dir_3sgust":null,"Dir_stdev":null,"gust_3stime":null,"Pressure":null,"dewpoint":null,"Hum_SHT":null,"TempC_DS":null,"TempC_SHT":null,"Temp_Black":null,"Temp_Red":null,"Temp_White":null},"geometry":{"type":"Point","coordinates":[6.188925,46.148539]}},{"type":"Feature","properties":{"spot_id":"CHGE05","spotname":"Troinex","webcamlink":"","webcamlink2":null,"webcamlink3":null,"webcamlink4":null,"active":"1","source":"Windspots","icon":"logo","windave":"0.00","windir":"171","Battery":null,"Wind_3sgust":"0.00","Wind_3smin":null,"Wind_stdev":null,"Dir_3sgust":null,"Dir_stdev":null,"gust_3stime":null,"Pressure":"1019.00","dewpoint":null,"Hum_SHT":null,"TempC_DS":null,"TempC_SHT":"19.00","Temp_Black":null,"Temp_Red":null,"Temp_White":null},"geometry":{"type":"Point","coordinates":[6.157252,46.162252]}},{"type":"Feature","properties":{"spot_id":"CHVD12","spotname":"Centre Lausannois Aviron","webcamlink":"","webcamlink2":null,"webcamlink3":null,"webcamlink4":null,"active":"1","source":"Windspots","icon":"logo","windave":"0.00","windir":"0","Battery":null,"Wind_3sgust":"0.00","Wind_3smin":null,"Wind_stdev":null,"Dir_3sgust":null,"Dir_stdev":null,"gust_3stime":null,"Pressure":null,"dewpoint":null,"Hum_SHT":null,"TempC_DS":null,"TempC_SHT":null,"Temp_Black":null,"Temp_Red":null,"Temp_White":null},"geometry":{"type":"Point","coordinates":[6.601139,46.512496]}},{"type":"Feature","properties":{"spot_id":"CHVD15","spotname":"Corseaux - La Pichette","webcamlink":"","webcamlink2":null,"webcamlink3":null,"webcamlink4":null,"active":"1","source":"Windspots","icon":"logo","windave":"1.62","windir":"355","Battery":null,"Wind_3sgust":"1.94","Wind_3smin":null,"Wind_stdev":null,"Dir_3sgust":null,"Dir_stdev":null,"gust_3stime":null,"Pressure":"1018.00","dewpoint":null,"Hum_SHT":null,"TempC_DS":null,"TempC_SHT":"24.80","Temp_Black":null,"Temp_Red":null,"Temp_White":null},"geometry":{"type":"Point","coordinates":[6.811508,46.469174]}},{"type":"Feature","properties":{"spot_id":"CHVS02","spotname":"Planachaux","webcamlink":"","webcamlink2":null,"webcamlink3":null,"webcamlink4":null,"active":"1","source":"Windspots","icon":"logo","windave":"7.78","windir":"266","Battery":null,"Wind_3sgust":"8.42","Wind_3smin":null,"Wind_stdev":null,"Dir_3sgust":null,"Dir_stdev":null,"gust_3stime":null,"Pressure":null,"dewpoint":null,"Hum_SHT":null,"TempC_DS":null,"TempC_SHT":"16.00","Temp_Black":null,"Temp_Red":null,"Temp_White":null},"geometry":{"type":"Point","coordinates":[6.840267,46.177117]}},{"type":"Feature","properties":{"spot_id":"vengeron","spotname":"Vengeron.net","webcamlink":"https:\/\/camstreamer.com\/embed\/5QSFHqNMXdfZPRsP6R4LRYG8PlFvzgOVxFoAMRfT","webcamlink2":null,"webcamlink3":null,"webcamlink4":null,"active":"1","source":"Vengeron","icon":"logo","windave":null,"windir":null,"Battery":null,"Wind_3sgust":null,"Wind_3smin":null,"Wind_stdev":null,"Dir_3sgust":null,"Dir_stdev":null,"gust_3stime":null,"Pressure":null,"dewpoint":"15.3","Hum_SHT":"61.0","TempC_DS":null,"TempC_SHT":"23.40","Temp_Black":"20.60","Temp_Red":"20.60","Temp_White":"20.60"},"geometry":{"type":"Point","coordinates":[6.153731,46.245619]}},{"type":"Feature","properties":{"spot_id":"CHGE03","spotname":"Soci\u00e9t\u00e9 Nautique de Gen\u00e8ve","webcamlink":"","webcamlink2":null,"webcamlink3":null,"webcamlink4":null,"active":"1","source":"Windspots","icon":"logo","windave":"2.59","windir":"69","Battery":null,"Wind_3sgust":"2.59","Wind_3smin":null,"Wind_stdev":null,"Dir_3sgust":null,"Dir_stdev":null,"gust_3stime":null,"Pressure":"1016.00","dewpoint":null,"Hum_SHT":null,"TempC_DS":null,"TempC_SHT":"22.00","Temp_Black":null,"Temp_Red":null,"Temp_White":null},"geometry":{"type":"Point","coordinates":[6.171121,46.21425]}},{"type":"Feature","properties":{"spot_id":"silva","spotname":"Conches","webcamlink":"","webcamlink2":null,"webcamlink3":null,"webcamlink4":null,"active":"1","source":"TrueWindSpeed","icon":"logo","windave":null,"windir":null,"Battery":null,"Wind_3sgust":null,"Wind_3smin":null,"Wind_stdev":null,"Dir_3sgust":null,"Dir_stdev":null,"gust_3stime":null,"Pressure":null,"dewpoint":null,"Hum_SHT":null,"TempC_DS":null,"TempC_SHT":null,"Temp_Black":null,"Temp_Red":null,"Temp_White":null},"geometry":{"type":"Point","coordinates":[6.179498,46.188946]}},{"type":"Feature","properties":{"spot_id":"silva","spotname":"Silvaplana","webcamlink":"","webcamlink2":null,"webcamlink3":null,"webcamlink4":null,"active":"0","source":"TrueWindSpeed","icon":"logo","windave":null,"windir":null,"Battery":null,"Wind_3sgust":null,"Wind_3smin":null,"Wind_stdev":null,"Dir_3sgust":null,"Dir_stdev":null,"gust_3stime":null,"Pressure":null,"dewpoint":null,"Hum_SHT":null,"TempC_DS":null,"TempC_SHT":null,"Temp_Black":null,"Temp_Red":null,"Temp_White":null},"geometry":{"type":"Point","coordinates":[6.179498,46.188946]}},{"type":"Feature","properties":{"spot_id":"silva","spotname":"Silvaplana","webcamlink":null,"webcamlink2":null,"webcamlink3":null,"webcamlink4":null,"active":"0","source":"TrueWindSpeed","icon":"logo","windave":null,"windir":null,"Battery":null,"Wind_3sgust":null,"Wind_3smin":null,"Wind_stdev":null,"Dir_3sgust":null,"Dir_stdev":null,"gust_3stime":null,"Pressure":null,"dewpoint":null,"Hum_SHT":null,"TempC_DS":null,"TempC_SHT":null,"Temp_Black":null,"Temp_Red":null,"Temp_White":null},"geometry":{"type":"Point","coordinates":[6.179498,46.188946]}}]}}




const pointSource = {"type":"geojson","data":{"type":"FeatureCollection","features":[{"type":"Feature","properties":{"spot_id":"wbgt-chando","spotname":"Terminal Sud","altitude":"0","webcamlink":"","webcamlink2":null,"webcamlink3":null,"webcamlink4":null,"active":"1","source":"gva","received_at":"2024-02-28 17:11:57","icon":"logo","windave":null,"windir":null,"Battery":null,"Wind_3sgust":null,"Wind_3smin":null,"Wind_stdev":null,"Dir_3sgust":null,"Dir_stdev":null,"gust_3stime":null,"Pressure":null,"QNH":null,"Irradiation":null,"dewpoint":null,"Hum_SHT":"67.7","TempC_DS":null,"TempC_SHT":"9.50","WTMP":null,"Temp_Red":"99.00","Temp_White":"99.00","RH":"67.70","TG":"9.3","TA":"9.5","WBT":"6.93","WBGT":"7.66"},"geometry":{"type":"Point","coordinates":[6.101728,46.231578,0]}}]}}




export function App() {
  const { t } = useTranslation();

  // const [loggedInUser, setLoggedInUser] = useState(null);
  // const [source_list, setSource_list] = useState(['Demo','gva']);
  const [loggedInUser, setLoggedInUser] = useState('GIGI');
  const [source_list, setSource_list] = useState(['Eqs-SE-1','Eqs-NE-1','Eqs-DE-1','BYCN-MCO-1','BYCN-S-1','BYCN-S-2','BYCN-S-3','BYCN-E-1','BYCN-E-2','Hopital VS','SSE','Demo','TrueWindSpeed','METAR','Windspots','NOAA']);


  // setSource_list(['Eqs-SE-1','Eqs-NE-1','Eqs-DE-1','BYCN-MCO-1','BYCN-S-1','BYCN-S-2','BYCN-S-3','BYCN-E-1','BYCN-E-2','Hopital VS','SSE','Demo','TrueWindSpeed','METAR','Windspots','NOAA']);


  // const handleLogin = (username, source_list, def_spot) => {
  //   // Effectuez ici la vérification du mot de passe, par exemple avec une API, une base de données, etc.
  //   // Si les informations sont correctes, connectez l'utilisateur en mettant à jour l'état loggedInUser

  //   setLoggedInUser(username);
  //   setSource_list(source_list);

  //   // setdef_spot(def_spot);
  //   setSpot(def_spot);
  //   // spot={spot}
  //   // setSpot={setSpot}

  // };



  const [error404, setError404] = useState(false);


  const [selectedTab, setSelectedTab] = React.useState(0);
  const [spot, setSpot] = useState('wbgt-chando');
  const [Long, setLong] = useState(6.731444);
  const [Lat, setLat] = useState(46.331442);
  const [Zoom, setZoom] = useState(12);






  const [CAV, setCAV] = useState(0);

  const [fcast_hist, setfcast_hist] = useState(false);

  const [CAV_key, setCAV_key] = useState(0);
  const [M, setM] = useState(300);
  const [M_key, setM_key] = useState(2);



  
  // const [LaSource, setLaSource] = useState('TrueWindSpeed');

  
  const [styleUrl, setstyleUrl] = useState(outdoor_style);
  // const [styleUrl, setstyleUrl] = useState(dark_style);
  // const [styleUrl, setstyleUrl] = useState('https://tiles.stadiamaps.com/styles/alidade_smooth.json'); //'https://vectortiles.geo.admin.ch/styles/ch.swisstopo.leichte-basiskarte.vt/style.json');
  // const [styleUrl, setstyleUrl] = useState('https://tiles.stadiamaps.com/styles/alidade_smooth.json'); //'https://vectortiles.geo.admin.ch/styles/ch.swisstopo.leichte-basiskarte.vt/style.json');
  const [MapLayer, setMapLayer] = useState (
    {
      wind: false,
      wbgt: true,
      temp: false,
      hum: false,
      press: false,
      lux: false,
      eau: false,
      wave:false,
      tide:false,

      rssi:false,
      BatV:false
      // Ajoutez d'autres couches ici
    }
  );
  // const [selectedSwissLayers, setSelectedSwissLayers] = useState(['swissbathy3d']);
  const [selectedSwissLayers, setSelectedSwissLayers] = useState([]);

  //const [test1, settest1] = useState('test1');
  //const [test2, settest2] = useState('test2');
  const [timelaps, setTimelaps] = useState(6); 

  

  const handleMarkerClick = (value, mapLong, mapLat, mapzoom, styleUrl, source) => {
    setSpot(value);
    setLong(mapLong);
    setLat(mapLat);
    setZoom(mapzoom);
    setstyleUrl(styleUrl);
    setSelectedTab(0);
    // setLaSource(source);
    //settest1(tes1t);
    //settest2(tes2t);
    
  };


  const handleMapMove = (mapLong, mapLat, mapzoom) => {
    setLong(mapLong);
    setLat(mapLat);
    setZoom(mapzoom);
  };
  // const handleMapCamMove = (mapLong, mapLat, mapzoom, timelaps) => {
  //   setLong(mapLong);
  //   setLat(mapLat);
  //   setZoom(mapzoom);
  //   setTimelaps(timelaps);
  // };
  const handleMapCamMove = (mapLong, mapLat, mapzoom) => {
    setLong(mapLong);
    setLat(mapLat);
    setZoom(mapzoom);
  };
  const changemonURL = (styleUrl) => {
    setstyleUrl(styleUrl);
  };
  const changemonMapLayer = (MapLayer) => {
    setMapLayer(MapLayer);
  };
  const changemaSwissLayer = (selectedSwissLayers) => {
    setSelectedSwissLayers(selectedSwissLayers);
    console.log('selectedSwissLayers')
    console.log(selectedSwissLayers)
  };
  
  const changemonTimelabs = (timelaps) => {
    setTimelaps(timelaps);
  };

  const selectstationselect = (mapLong, mapLat) => {
    setLong(mapLong);
    setLat(mapLat);
  };



  const [geojsonData, setGeojsonData] = useState(pointSource);

  

  const fetchData = async () => {
    // const url1 = `./jsondata/superlast.php?long=${encodeURIComponent(Long)}&lat=${encodeURIComponent(Lat)}&source_list=${encodeURIComponent(source_list)}`; //'https://truewindspeed.ch/jsondata/last.php';
    const url1 = `./jsondata/superlast.php?long=${encodeURIComponent(Long)}&lat=${encodeURIComponent(Lat)}&source_list=${encodeURIComponent(source_list.join(','))}`; //'https://truewindspeed.ch/jsondata/last.php';
    // const url2 = './jsondata/last.geojson'; //'https://truewindspeed.ch/jsondata/last.geojson';

    try {
      const race = Promise.race([
        fetch(url1),
        // fetch(url2)
      ]);
      const response = await race;

      // Si une erreur 404 est détectée, déclenche l'action de vidage du cache et de rechargement de la page
      if (response.status === 404) {
        setError404(true);
        clearCacheAndReload();
      } else {
        // Traitement normal des données
        const data = await response.json();
        setGeojsonData(data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  // const fetchMETARData = async () => {
  //   // const url2 = './jsondata/lastMETAR.php'; //'https://truewindspeed.ch/jsondata/last.php';
  //   const url2 = './lastMETAR.php'; //'https://truewindspeed.ch/jsondata/last.php';
  //   // const url2 = './jsondata/last.geojson'; //'https://truewindspeed.ch/jsondata/last.geojson';

  //   try {
  //     const race = Promise.race([
  //       fetch(url2),
  //       // fetch(url2)
  //     ]);
  //     const response = await race;
  //     console.log('response')
  //     console.log(response)

  //     // Si une erreur 404 est détectée, déclenche l'action de vidage du cache et de rechargement de la page
  //     if (response.status === 404) {
  //       setError404(true);
  //       clearCacheAndReload();
  //     } else {
  //       // Traitement normal des données
  //       const data = await response.json();
  //       console.log('data')
  //       console.log(data)
  //       setGeojsonMetar(data);
  //     }
  //   } catch (error) {
  //     console.error(error);
  //   }
  // };

  const clearCacheAndReload = () => {
    if ('caches' in window) {
      // Supprime tous les caches existants
      caches.keys().then((cacheNames) => {
        cacheNames.forEach((cacheName) => {
          caches.delete(cacheName);
        });
      });
    }

    // Recharge la page
    window.location.reload(true);
  };


  useEffect(() => {
    // console.log('App2 try fetch pointsource')
    const interval = setInterval(() => { //refreash toutes les x secondes
      fetchData(); // refetch les données lorsque hours est mis à jour
      // fetchMETARData(); // refetch les données lorsque hours est mis à jour
    }, 60000); //refreash toutes les x secondes
    // console.log('App interval fetch pointsource')
    fetchData(); // refetch les données lorsque hours est mis à jour
    // fetchMETARData(); // refetch les données lorsque hours est mis à jour
    // console.log('App triger fetch pointsource')
    return () => clearInterval(interval); // refetch les données lorsque hours est mis à jour
  }, [source_list]); // refetch les données lorsque hours est mis à jour
  // }, [spot, Long, Lat, Zoom]); // refetch les données lorsque hours est mis à jour
// }, [spot]); // refetch les données lorsque hours est mis à jour


  
  return (



    <div>
      {loggedInUser ? (
        // Affichez votre application ici une fois l'utilisateur connecté
        // <div>Welcome, {loggedInUser}!</div>
        <Container fluid>
      <br />
      {error404 &&
        <Alert variant="info" onClose={() => setError404(false)} dismissible>
          <Alert.Heading>Update... ⏳</Alert.Heading>
          <p>
          <br></br>
            Your App has been succesfully updated and is reloading
          <br></br>
          </p>
        </Alert>
      }
      
      {selectedTab === 0 ? (
        <>
        {/* <p>Bonjour, </p>
        <p>Bienvenu {loggedInUser}</p> */}
        <Chart
        loggedInUser={loggedInUser}
        selectstation={selectstationselect}
        // slectspot={spot}
        spot={spot}
        setSpot={setSpot}
        Long={Long}
        setLong={setLong}
        Lat={Lat}
        setLat={setLat}
        pointSource={geojsonData}

        fcast_hist={fcast_hist}
        setfcast_hist={setfcast_hist}

        
        CAV={CAV}
        setCAV={setCAV}
        CAV_key={CAV_key}
        setCAV_key={setCAV_key}
        M={M}
        setM={setM}
        M_key={M_key}
        setM_key={setM_key}


        source_list={source_list}
        
        // LaSource={LaSource}
        />
        {/* <Contact /> */}
        </>
        ) : selectedTab === 1 ? (
        <Map
        loggedInUser={loggedInUser}

        onMarkerClick={handleMarkerClick}
        onMove={handleMapMove}
        changeURL={changemonURL}
        changeMapLayer={changemonMapLayer}
        changeSwissLayer={changemaSwissLayer}
        centerLongitude={Long}
        centerLatitude={Lat}
        zoom={Zoom}
        pitch={10}
        bearing={0}
        defstyleUrl={styleUrl}
        defMapLayer={MapLayer}
        defselectedSwissLayers={selectedSwissLayers}
        exaggeration={30}
        markerLongitude={6.231444}
        markerLatitude={Lat}
        nom="nom"
        spotname="spotname"
        pointSource={geojsonData}


        CAV={CAV}
        setCAV={setCAV}
        M={M}
        setM={setM}
        />
        ) 
        : selectedTab === 3 ? (
          <>
          {/* <p>Bonjour, </p>
          <p>Bienvenu {loggedInUser}</p> */}
          <Navy
          loggedInUser={loggedInUser}
          selectstation={selectstationselect}
          // slectspot={spot}
          spot={spot}
          setSpot={setSpot}
          Long={Long}
          setLong={setLong}
          Lat={Lat}
          setLat={setLat}
          pointSource={geojsonData}
  
          fcast_hist={fcast_hist}
          setfcast_hist={setfcast_hist}
  
  
          source_list={source_list}
          
          // LaSource={LaSource}
          />
          {/* <Contact /> */}
          </>
          )
        // : selectedTab === 2 ? (
        //   <MapCam
        //   onMove={handleMapCamMove}
        //   changeTimelaps={changemonTimelabs}
        //   centerLongitude={Long}
        //   centerLatitude={Lat}
        //   zoom={Zoom}
        //   pitch={10}
        //   bearing={0}
        //   defstyleUrl={styleUrl}
        //   deftimelaps={timelaps}
        //   exaggeration={30}
        //   images={images}
        //   />
        //   // ) : selectedTab === 3 ? (
        //   //   <MapTrack
        //   //   onMove={handleMapCamMove}
        //   //   changeTimelaps={changemonTimelabs}
        //   //   centerLongitude={Long}
        //   //   centerLatitude={Lat}
        //   //   zoom={Zoom}
        //   //   pitch={10}
        //   //   bearing={0}
        //   //   defstyleUrl={styleUrl}
        //   //   deftimelaps={timelaps}
        //   //   exaggeration={30}
        //   //   images={tracker}
        //   //   />
        //   ) 
        // : selectedTab === 3 ? (
        //     <Clock montre={1}/>
        // )
        : selectedTab === 4 ? (
          <PHS/>
        )


           : (
            <Clock montre={1}/>
          )}

        <SimpleBottomNavigation
        value={selectedTab}
        onChange={(event, newValue) => {
          setSelectedTab(newValue);
        }}
        />
    </Container>

      ) : (
        // Affichez la page de connexion si l'utilisateur n'est pas connecté
        <Login
        // onLogin={handleLogin}
        setLoggedInUser={setLoggedInUser}
        setSource_list={setSource_list}
        setSpot={setSpot}
        />
      )}
    </div>


    

    



  );
}



{/*
          <MapCam
          onMove={handleMapCamMove}
          changeTimelaps={changemonTimelabs}
          centerLongitude={Long}
          centerLatitude={Lat}
          zoom={Zoom}
          pitch={10}
          bearing={0}
          defstyleUrl={styleUrl}
          deftimelaps={timelaps}
          exaggeration={30}
          />
*/}